<template>
  <!-- 列表弹出框 -->
  <div>
    <van-popup
      class="box"
      v-model="show"
      position="bottom"
      :style="{ height: '90%' }"
    >
      <div class="header">
        <span class="title">{{ header }}</span>
        <img @click="close" class="close-icon" src="../../../../assets/refund/down.png" alt="">
        <!-- <van-icon
          @click="close"
          size="12px"
          name="cross"
          color="#A2A3A4"
        /> -->
      </div>
      <div v-if="datalist.length > 0" class="person-list">
        <div
          v-for="(item, index) of datalist"
          :key="index"
          class="person-item"
          @click="selectItem(item)"
        >
          <div class="item-left">
            <p class="name">{{ item.centerName }}</p>
            <p v-if="item && item.address" class="address">{{ item.address }}</p>
            <p v-else class="address">没有相关地址</p>
          </div>
          <van-icon
            v-if="item.id === selItem.id"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
      <div v-else class="box1">
        <img src="../../../../assets/empty/ic_wuxingxi.png" />
        <p class="tip1">暂无数据</p>
      </div>
    </van-popup>

  </div>
</template>
<script>
    export default {
        props: ['datalist', 'header'],
        data () {
            return {
                selItem: {},
                show: false
            }
        },
        methods: {
            init (item) {
                this.show = true
                if (item) {
                    this.selItem = item
                }
            },
            // 点击列表项
            selectItem (item) {
                this.selItem = item
                // this.$emit('select', this.selItem)
                this.close()
            },
            close () {
                this.show = false
                this.$emit('close', this.selItem)
            }
        }
    }
</script>

<style lang="less" scoped>
  .box {
    padding: 0 16px;
    .header {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      position: fixed;
      background-color: white;
      width: 92vw;
      .close-icon{
        width: 12px;
        height: 12px;
      }
      .title {
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 11px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }
    .person-list {
      height: 650px;
      overflow: auto;
      padding-bottom: 50px;
      margin-top: 54px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        padding: 20.5px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f9;
        .item-left {
          .name {
            font-size: 16px;
            color: #171A1D;
            font-weight: 400;
          }
          .address {
            font-size: 12px;
            color: #9DA0A4;
            font-weight: 400;
            margin-top: 6px;
          }
        }
        .select-icon {
          font-size: 17px;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
</style>
